import './polyfills'

import settings, { loadConfig } from 'settings'
import { DESIGN_QA_SCENARIOS_ENABLED, mayHaveDesignQaScenario } from '@cloud-native/design-qa-scenarios'

const bootstrapApp = async () => {
  if (DESIGN_QA_SCENARIOS_ENABLED && mayHaveDesignQaScenario(window.location.search)) {
    // A broken scenario must never stop the app from booting
    try {
      const [{ installDesignQaScenarios, apiOriginsFrom }, { DESIGN_QA_INITIATIVES }] = await Promise.all([
        import('@cloud-native/design-qa-scenarios/runtime'),
        import('./devtools/designQa/initiatives')
      ])
      // Settings load after install; fixtures answer only the app's own APIs
      await installDesignQaScenarios(DESIGN_QA_INITIATIVES, { apiOrigins: () => apiOriginsFrom(settings) })
    } catch (error) {
      console.error('Design QA scenarios failed to install', error)
    }
  }

  await loadConfig()

  const { renderApp } = await import('./ReactApp')
  renderApp()
}

bootstrapApp()
